import useVuelidate from '@vuelidate/core';
import debounce from 'lodash/debounce';
import { mapActions, mapState } from 'vuex';

import {
  addInputEventListener,
  numberInputHandler,
  removeInputEventListener,
} from '@/utils/helper';
import {
  account as accountRule,
  email as emailRule,
  identification as identificationRule,
  password,
  required,
} from '@/utils/validators';

export default {
  name: 'FirstStep',
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      form: {
        account: '',
        email: '',
        password: '',
        identification: '',
        subscribed_weiby: false,
      },
      duplicatedIdentification: false,
    };
  },
  computed: {
    ...mapState('user', {
      registerForm: ({ registerForm }) => registerForm,
    }),
    getAccountMsg() {
      return this.hasErrorMsgs('account')
        ? this.getErrorMsgs('account') : '登入帳號限使用英文字母、數字或符號';
    },
    getIdentificationMsg() {
      return this.duplicatedIdentification
        ? '統一編號已存在，請輸入其他統一編號。' : this.getErrorMsgs('identification');
    },
    getPasswordMsg() {
      return this.hasErrorMsgs('password')
        ? this.getErrorMsgs('password') : '密碼限8個字元以上，並且必須包含英文字母及數字';
    },
    hasIdentificationError() {
      return this.duplicatedIdentification || this.hasErrorMsgs('identification');
    },
  },
  mounted() {
    const {
      account,
      email,
      identification,
      subscribed_weiby: subscribe,
      password: pwd,
    } = this.registerForm;
    this.form = {
      ...this.form,
      ...{
        account,
        email,
        identification,
        subscribed_weiby: subscribe,
        password: pwd,
      },
    };
    addInputEventListener(
      this.$refs.identificationInput,
      'keydown',
      this.onNumberInputKeydown,
    );
  },
  beforeDestroy() {
    removeInputEventListener(
      this.$refs.identificationInput,
      'keydown',
      this.onNumberInputKeydown,
    );
  },
  methods: {
    ...mapActions('user', {
      checkIdentification: 'CHECK_IDENTIFICATION',
      setRegisterForm: 'SET_USER_REGISTER_FORM',
    }),
    checkId: debounce(async function checkId(identification) {
      try {
        const { exists } = await this.checkIdentification(identification);
        this.duplicatedIdentification = exists;
      } catch {
        this.duplicatedIdentification = false;
      }
    }, 500),
    async next() {
      const valid = await this.v$.$validate();
      if (!valid) return;

      this.setRegisterForm({ ...this.form, subscribed_weiby: !!this.form.subscribed_weiby });
      this.$emit('next');
    },
    getErrorMsgs(field) {
      return this.v$.form?.[field]?.$errors?.[0]?.$message;
    },
    hasErrorMsgs(field) {
      return this.v$.form?.[field]?.$errors?.length;
    },
    onNumberInputKeydown(event) {
      numberInputHandler(event);
    },
  },
  watch: {
    'form.identification': {
      handler(newVal, oldVal) {
        if (newVal && newVal !== oldVal) {
          this.checkId(newVal);
        }
      },
    },
  },
  validations() {
    return {
      form: {
        account: { required: required('登入帳號'), accountRule },
        email: { required: required('電子郵件'), emailRule },
        identification: {
          required: required('統一編號'),
          identificationRule,
        },
        password: { required: required('密碼'), password },
      },
    };
  },
};
